/* eslint-disable react/prop-types */
import React, { CSSProperties, Component } from 'react';
import Menu from '@tencent/dui/lib/components/Menu';
import Divider from '@tencent/dui/lib/components/Divider';
import { ActionType, ChildActionType } from '../../../../editor/src/js/constants/common-action-type';
import styles from './font-menu.css';

const menuStyle = {
    border: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    backdropFilter: 'none',
    padding: 0,
};
const FONT_SIZE_MENU_WIDTH = 80;
const FONT = 'font';
// 设置火狐浏览器的scrollbar的宽度
const FIREFOX_SCROLL_BAR_WIDTH = 'thin';

export interface FontMenuProps {
    data: Array<any>;
    onMenuClick?: (id: number) => void;
    type: string;
    id: string;
    checkSelectedValue: boolean;
    selectedIndex: number;
}

interface FontMenuState {
    config: { vh: number; height: number; }
}

export default class FontMenu extends Component<FontMenuProps, FontMenuState> {
    public static defaultProps = {
        data: [],
        onMenuClick() {},
    };
    public constructor(props) {
        super(props);
        this.state = {
            config: {
                vh: 0,
                height: 0,
            },
        };
    }

    public render() {
        // props 实际包含多个父层组件透传的属性，不仅仅只有描述的两个
        const { props } = this;
        // props.type 为 font 时此为字号选择组件
        const customMenuStyle: CSSProperties = props.type === FONT
            ? { ...menuStyle, width: FONT_SIZE_MENU_WIDTH, scrollbarWidth: FIREFOX_SCROLL_BAR_WIDTH }
            : menuStyle;
        const menuId = props.id;

        return (
            <Menu
                onClick={this.handleMenuClick}
                selectable={props.checkSelectedValue}
                selectedIds={[String(props.selectedIndex)]}
                type={
                    props?.checkSelectedValue && props.data.some(({ imgSrc }) => Boolean(imgSrc))
                        ? 'with-icon'
                        : 'normal'
                }
                style={customMenuStyle}
                className="menu-scroll"
            >
                {props.data?.map(({ id, imgSrc, content, disabled }, i) => {
                    if (id === ActionType.DIVIDER) {
                        // 分割线
                        return (
                            <Divider
                                key={i}
                                orientation="horizontal"
                                style={{
                                    verticalAlign: 'middle',
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                    opacity: 0.82,
                                }}
                            />
                        );
                    }
                    // 合并文字与图片，没有 icon 即为 undefined，组件库不显示图标
                    return (
                        <Menu.Item
                            id={String(i)}
                            key={i}
                            icon={imgSrc}
                            className={`${menuId === ChildActionType.ALIGN ? styles['align-item'] : ''} font-menu-item-for-e2e-locate`}
                            disabled={disabled}
                        >
                            {content}
                        </Menu.Item>
                    );
                })}
            </Menu>
        );
    }

    private handleMenuClick = (id) => {
        if (this.props.onMenuClick) {
            this.props.onMenuClick(parseInt(id, 10));
        }
    };
}
